export const get_shop_mixins = {
  data() {
    return {
      shopee_shop: {
        loading: false,
        list: [],
        selected: ''
      },
      shop: {},
    }
  },

  methods: {
    async m__get_shopee_shop(show_ntf = true) {
      this.shopee_shop.loading = true
      try {
        const sync_status_resp = await this.$http.get('https://api.atosa.asia/api/v1/open-platform/sync-status', this.cf())
        const shop_sync = sync_status_resp.body.data

        const resp = await this.$http.get(this.API.shopee_manager__get_shop + '?channel=shopee_marketing', this.cf())
        const resp_sub_account = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/sub_account/get_shop', this.cf())

        for (const shop of resp.body.data) {
          const found = shop_sync.find(i => i.shop_id === shop.shop_id)
          shop.extra_data.linked = !!found
          shop.extra_data.sync = found && found.sync && found.sync.shopee_order
        }
        for (const shop of resp_sub_account.body.data) {
          if (!shop.extra_data.linked) {
            shop.extra_data.linked = shop_sync.some(i => i.shop_id === shop.shop_id)
          }
        }

        this.shopee_shop.list = [...resp.body.data, ...resp_sub_account.body.data]

        // todo: test
        // this.shopee_shop.list = this.shopee_shop.list.filter(i => i.username === 'pacofood')

        const shop_default = this.shopee_shop.list.length === 1
          ? this.shopee_shop.list[0]
          : this.$route.query.shop_id ? this.shopee_shop.list.find(i => i.shop_id === this.$route.query.shop_id) : this.shopee_shop.list.find(i => !i.is_sub_account && i.extra_data && i.extra_data.default)
        if (shop_default) {
          this.shopee_shop.selected = shop_default._id
          if (show_ntf) this.ntf_s(`${this.$t('shop.selected_default')}: ${shop_default.username}`)
        }

        setTimeout(() => {
          if (!this.shopee_shop.list.length) {
            this.EB.$emit('show_no_shop_dialog')
          }
        }, 1000)
      } catch (e) {
        console.error(e)
      } finally {
        this.shopee_shop.loading = false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/get_shop.js